<template>
  <el-dialog
    title="定位员工"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose"
  >
    <el-row>
      <el-col :span="18">
        <el-input
          placeholder="输入员工名称"
          v-model="searchStaffInfo._currentStaffName"
          class="input-with-select"
        >
          <el-button 
            slot="append" 
            icon="el-icon-search"
            @click="searchStaffs"
          >查询</el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table
      :data="searchStaffInfo.staffs"
      style="width: 100%; margin-top: 20px;"
      border
      stripe
    >
      <el-table-column prop="userId" label="员工编码" align="center"></el-table-column>
      <el-table-column prop="name" label="员工名称" align="center"></el-table-column>
      <el-table-column prop="tel" label="手机号" align="center"></el-table-column>
      <el-table-column label="性别" align="center">
        <template slot-scope="scope">
          {{scope.row.sex === 0 ? '男' : (scope.row.sex === 1 ? '女' : '')}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="chooseStaff(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { listStaffs } from '@/api/frame/searchStaffApi'

export default {
  name: 'SearchStaff',
  props: {
    callBackListener: {
      type: String,
      default: 'privilegeStaffInfo'
    },
    callBackFunction: {
      type: String,
      default: 'chooseStaff'
    }
  },
  data() {
    return {
      dialogVisible: false,
      searchStaffInfo: {
        staffs: [],
        _currentStaffName: '',
        orgId: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._refreshSearchStaffData()
      this._loadAllStaffInfo(1, 10)
    },
    handleClose() {
      this.dialogVisible = false
    },
    _loadAllStaffInfo(_page, _rows, _staffName) {
      const params = {
        page: _page,
        row: _rows,
        staffName: _staffName,
        orgId: this.searchStaffInfo.orgId
      }
      
      listStaffs(params)
        .then(response => {
          this.searchStaffInfo.staffs = response.staffs
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    chooseStaff(staff) {
      this.$emit(this.callBackFunction, staff)
      this.$emit('loadStaffPrivileges', {
        staffId: staff.userId
      })
      this.dialogVisible = false
    },
    searchStaffs() {
      this._loadAllStaffInfo(1, 10, this.searchStaffInfo._currentStaffName)
    },
    _refreshSearchStaffData() {
      this.searchStaffInfo._currentStaffName = ""
    }
  }
}
</script>

<style scoped>
.input-with-select {
  margin-bottom: 20px;
}
</style>